export default "__VITE_PUBLIC_ASSET__a224cede__"